import { render, staticRenderFns } from "./BlogCard.vue?vue&type=template&id=5af1114e&scoped=true"
import script from "./BlogCard.vue?vue&type=script&lang=js"
export * from "./BlogCard.vue?vue&type=script&lang=js"
import style0 from "./BlogCard.vue?vue&type=style&index=0&id=5af1114e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af1114e",
  null
  
)

export default component.exports